import { create } from 'zustand';

import { AlertModalProps } from '../Member/components/AlertModal';
import { createSelectors } from '../utils/zustand/createSelectors';

interface AlertModalStore {
  /** 알림 모달 Props */
  alertModal: AlertModalProps | null;

  /** 알림 모달 설정 */
  setAlertModal: (alertModal: AlertModalProps | null) => void;
}

/**
 * 알림 모달 상태를 관리하는 Zustand store
 */
const useAlertModalStoreBase = create<AlertModalStore>((set) => ({
  alertModal: null,
  setAlertModal: (alertModal) => set({ alertModal }),
}));

export const useAlertModalStore = createSelectors(useAlertModalStoreBase);
